import { Injectable, inject } from '@angular/core';
import {
  IControlSirena,
  ICrearControlSirena,
  IListado,
  IQueryParam,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { HelperService } from '../../auxiliares/servicios/helper.service';
import { HttpApiAdminService } from '../../auxiliares/servicios/http-api.service';

@Injectable({
  providedIn: 'root',
})
export class ControlesSirenasService {
  private http = inject(HttpApiAdminService);
  private helper = inject(HelperService);

  public listar(
    queryParams?: IQueryParam,
  ): Observable<IListado<IControlSirena>> {
    let params = this.helper.getQueryParams(queryParams);
    return this.http.get(`/controlesSirenas`, { params });
  }

  public listarPorId(id: string): Observable<IControlSirena> {
    return this.http.get(`/controlesSirenas/${id}`);
  }

  public crear(dato: ICrearControlSirena): Observable<IControlSirena> {
    return this.http.post(`/controlesSirenas`, dato);
  }

  public eliminar(id: string): Observable<IControlSirena> {
    return this.http.delete(`/controlesSirenas/${id}`);
  }
}
